import { render, staticRenderFns } from "./epb-color-picker.component.vue?vue&type=template&id=67ab74b4&scoped=true"
import script from "./epb-color-picker.component.vue?vue&type=script&lang=ts"
export * from "./epb-color-picker.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-color-picker.component.vue?vue&type=style&index=0&id=67ab74b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab74b4",
  null
  
)

export default component.exports